@if (nav.showNavbar) {
  <ng-container *transloco="let t">
    <div class="navbar" [ngClass]="nav.classList">
      <img class="logo-image" src="assets/logo.png" alt="Logo" />

      <!-- <h3 class="current-page-title">Tasks</h3> -->

      @if (authState.isLogged) {
        <div class="items-container">
          <a
            class="item-nav"
            routerLink="/home"
            [routerLinkActive]="['active']"
          >
            <span class="material-symbols-outlined">near_me</span>
            {{ t("home") }}
          </a>

          <a
            class="item-nav"
            routerLink="/rents"
            [routerLinkActive]="['active']"
          >
            <span class="material-symbols-outlined">key</span>
            {{ t("yourRentals") }}
          </a>

          <!-- <a
          #adminNav
          class="item-nav submenu-toggler"
          [class.active]="currentPathRoot === 'admin'"
          [class.submenu-active]="activeNavItem === 'admin'"
          (click)="toggleSubmenu(adminNav, 'admin', $event)"
        >
          <span class="material-symbols-outlined">settings</span>
          {{ t('admin') }}
        </a> -->

          @if (["1", "2", "3", "4"].includes(authState.loginData.user.authLevel)) {
            <a
              class="item-nav"
              routerLink="/admin/all"
              [routerLinkActive]="['active']"
              [class.active-forced]="currentPathRoot === 'admin'"
            >
              <span class="material-symbols-outlined">settings</span>
              {{ t("admin") }}
            </a>
          }

          <div
            #profileNav
            class="profile-nav submenu-toggler"
            [class.active]="currentPathRoot === 'admin'"
            [class.submenu-active]="nav.activeNavItem === 'profile'"
            (click)="toggleSubmenu(profileNav, 'profile', $event)"
          >
            @if (authState.loginData.picture) {
              <img
                [src]="authState.loginData.picture"
                [alt]="t('profilePicture')"
                class="profile-picture"
              />
            } @else {
              <span class="material-symbols-outlined">person</span>
            }
          </div>
        </div>

        <div class="submenu-arrow" [style.--x-offset]="submenuArrowLeft"></div>

        <div
          class="submenu-container"
          [class.visible]="nav.submenuVisible"
          [class.align-right]="submenuAlignment === 'right'"
          [ngStyle]="submenuPosition"
        >
          @if (submenuContext == "profile") {
            <a
              class="submenu-item"
              routerLink="/profile"
              [routerLinkActive]="['active']"
              (click)="closeSubmenu()"
            >
              <span class="material-symbols-outlined">person</span>
              {{ t("profile") }}
            </a>
            <a
              class="submenu-item"
              routerLink="/about"
              [routerLinkActive]="['active']"
              (click)="closeSubmenu()"
            >
              <span class="material-symbols-outlined">info</span>
              {{ t("about") }}
            </a>
            <a
              class="submenu-item"
              (click)="authState.logout(true); closeSubmenu()"
            >
              <span class="material-symbols-outlined">logout</span>
              {{ t("logout") }}
            </a>
          } @else if (submenuContext == "admin") {
            <a
              class="submenu-item"
              routerLink="/admin/mapview"
              [routerLinkActive]="['active']"
              (click)="closeSubmenu()"
            >
              <span class="material-symbols-outlined">pedal_bike</span>
              {{ t("bikesAndStations") }}
            </a>
            <a
              class="submenu-item"
              routerLink="/admin/tasks"
              [routerLinkActive]="['active']"
              (click)="closeSubmenu()"
            >
              <span class="material-symbols-outlined">task</span>
              {{ t("tasks") }}
            </a>
            <a
              class="submenu-item"
              routerLink="/admin/notifications"
              [routerLinkActive]="['active']"
              (click)="closeSubmenu()"
            >
              <span class="material-symbols-outlined">notifications</span>
              {{ t("notifications") }}
            </a>
            <a
              class="submenu-item"
              routerLink="/admin/reports"
              [routerLinkActive]="['active']"
              (click)="closeSubmenu()"
            >
              <span class="material-symbols-outlined">monitoring</span>
              {{ t("reports") }}
            </a>
            <a
              class="submenu-item"
              routerLink="/admin/all"
              [routerLinkActive]="['active']"
              (click)="closeSubmenu()"
            >
              <span class="material-symbols-outlined">apps</span>
              {{ t("all") }}
            </a>
          }
        </div>
      }
    </div>
  </ng-container>
}
